
import { Col, Layout, Select } from 'antd';
import 'antd/dist/antd.css';
import React from 'react';
import STYLES from '../../types/box_styles';
import '../index.css';
// https://react-icons.github.io/react-icons/#/
// https://stackoverflow.com/questions/39979325/partially-fill-a-shapes-border-with-colour
require('react-web-vector-icons/fonts');

const { Option } = Select;

const { Header, Content, Footer, Sider } = Layout;

export default class SSQaure extends React.Component {
    constructor(props) {
        super(props)


    }
    render() {


        return (
            <Col type="flex" style={{ width: 200, height: 100, border: '2px solid black', padding: '20px', margin: '20px', alignItems: 'center', display: 'flex', justifyContent: 'center' }}  >
     
                <div style={Object.assign({}, STYLES.RECTANGLE, this.props.style2)} > 
                    <div style={Object.assign({}, STYLES.RECTANGLE_SMALL,this.props.style2_small, { transform: 'rotate(-90deg)'})} >
                    </div>
                </div>

            </Col>
        )
    }
}